import { layoutOf } from '../../domain/layout';
import { dualAxle, singleAxle } from '../wheel-placements';
import { WATER_TANKER } from './dimensions';

const WATER_TANKER_WHEELS = WATER_TANKER.axles.flatMap((axle, index) => {
  const spec = {
    axle: index + 1,
    x: axle.x,
    radius: WATER_TANKER.wheelRadius,
    width: WATER_TANKER.tyreWidth,
    halfTrack: axle.halfTrack,
  };
  return axle.fitment === 'dual'
    ? dualAxle({ ...spec, spacing: WATER_TANKER.dualSpacing })
    : singleAxle(spec);
});

const WATER_TANKER_LAYOUT = layoutOf(['single', 'dual', 'dual']);

export {
  WATER_TANKER_LAYOUT,
  WATER_TANKER_WHEELS,
};
